import WallCommon from "./wallCommon";
import {Shower} from "../../parts/shower";
import {createPageToLoadArray} from "../../constants";
import {getCachedNoSizeName, removeShowerSizeFromName} from "../../featureNameMatching";

export default class SplitWall extends WallCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'split_wall';
    this.partName = 'Split Wall';
    this.translateId = "visualizer.bathroom.walls.split_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    // this.hasAdditionalParts = true;
    // this.additionalPartPartId = "split_wall_crop";
    if (isChild) {
      createPageToLoadArray(this);
    }
  }

  handleClick() {
    const showerParent = this.getParent().getParent().layout.parts[Shower.id];
    if (showerParent && showerParent.showerScreen) {
      showerParent.showerScreen.disabled = true;
    }
    super.handleClick();
  }

  /**
   * Removes shower size words from the name (they can be on a different position)
   * @param name {string}
   * @returns {string}
   */
  removeSizeFromMatchingName(name = "") {
    return removeShowerSizeFromName(name);
  }

  /**
   * getMatchingFeatureName() without shower size words, cached so we don't split it every time
   * @returns {string}
   */
  getNoSizeMatchingName() {
    return getCachedNoSizeName(this, "_noSizeMatchingName", this.getMatchingFeatureName());
  }

  /**
   * getSplittedFeatureName() without shower size words, cached so we don't split it every time
   * @returns {string}
   */
  getNoSizeSplittedName() {
    return getCachedNoSizeName(this, "_noSizeSplittedName", this.getSplittedFeatureName());
  }

  // setLayers(layout) { // we can't enable it since nothing will be selected on the very first load
  //   const wallParent = layout.parts[Shower.id];
  //   if (wallParent && wallParent.showerScreen && !wallParent.showerScreen.disabled) {
  //     super.hideLayers();
  //     return;
  //   }
  //   return super.setLayers(layout);
  // }

}

